/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Checkmark16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            d="M5.74 11.335l7.7-8.188a.499.499 0 01.707 0l.707.707a.502.502 0 010 .708l-7.7 8.188-1.13 1.133a.4.4 0 01-.503.051l-.063-.051-4.312-4.317a.502.502 0 010-.708l.707-.707a.499.499 0 01.707 0l3.18 3.184z"
            fill={vars.bdlGray50}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default Checkmark16;
